import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { catchError } from "rxjs/operators";

import { Observable, of } from "rxjs";

import { SpotlightPlant } from "@models/SpotlightPlant";

import { AppConfig } from "../app.config";

@Injectable({ providedIn: "root" })
export class SpotlightService {
  private serviceUrl: string = AppConfig.settings.serviceUrls.plantsServicesUrl; // base URL to web API

  constructor(private http: HttpClient) {}

  getSpotlightPlant(): Observable<SpotlightPlant> {
    return this.http.get<SpotlightPlant>(this.serviceUrl + "PlantSpotlight").pipe(
      catchError((err) => {
        console.log(err); //customize and log a better error elsewhere, also show a simple message to the user?
        return of(null); // consume: send null to the success path to keep app moving along
      })
    );
  }
}
